<!-- 富文本发布新闻 图文并茂 -->
<template>
<div class="detail-wrap" >
    <PageBack :title="title"></PageBack>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" 
        label-width="100px" class="demo-ruleForm">                   
        <el-row class="size20">
            <el-form-item label="新闻标题" prop="title">
                <el-input type="text" v-model="ruleForm.title" placeholder="请输入内容"/>
            </el-form-item>    
        </el-row>
        <el-row>
            <el-form-item>                
                <el-button type="success" @click="previewShow('ruleForm')"
                v-if="preShow">预览</el-button>
                <el-button type="danger" @click="saveNews('ruleForm')"
                v-if="preShow">保存</el-button>
                <el-button type="primary" @click="publishNews('ruleForm')" 
                :disabled="disabled">发布</el-button>
                <div class="red size18">注意：只能上传jpg/png文件，且不超过1M</div>  
            </el-form-item>
        </el-row>   
        <el-row>
            <el-form-item label="新闻内容" prop="des">
                <news-publisher ref="newsInfo" :value.sync="ruleForm.des"></news-publisher>
            </el-form-item>
        </el-row>                 
    </el-form>  
    <div class="news-description" v-if="showPreview">            
        <div class="icon-close" @click="handleClose"><i class="el-icon-close" size="30"></i></div>
        <div class="size18">新闻预览 
            <el-button type="info" @click="handleClose">关闭预览</el-button>
            <el-button type="primary" @click="publishNews('ruleForm')">发布</el-button>
        </div>
        <div class="detail-des-title">
            <p class="news-title">
                {{ ruleForm.title }}
            </p>
            <div class="ql-editor" v-html="ruleForm.des"></div>
        </div>
        <!-- <div class="dialog-footer">
            <el-button type="success" @click="previewNews('ruleForm')"
                v-if="preShow">生成预览链接</el-button>
            <el-button type="info" @click="handleClose">关闭</el-button>
        </div>             -->
    </div>
</div>
</template>
<script>
import PageBack from '@/components/PageHeader'
import newsPublisher from '@/components/NewsPublisher'
import { quillEditor } from 'vue-quill-editor'
export default {
    components:{
        PageBack,
        quillEditor,
        newsPublisher
    },
    data() {
        return {
            ruleForm: {
                title: '',
                des: '',           
            },
            rules:{
                title:[
                    { required: true, message: '请输入新闻标题', trigger: 'blur' },
                ],
                des: [
                    { required: true, message: '请输入新闻内容', trigger: 'blur' },
                ],
            },
            disabled: false,
            serialId: '',
            flag: 1,
            status: 0,
            showPreview: false,
            preShow: true,
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        },
    },
    created() {
        this.serialId = this.$route.query.id
        this.status = this.$route.query.status
    },
    mounted() {
        if(this.serialId){
            this.initData()
            if(this.status === '0'){
                this.preShow = false
            }
        }
    },
    methods: { 
        initData(){
            let params = {
                opcode: this.$code.NewsQuery,
                i_serial: this.serialId,
                v_title: '',
                c_status: this.status,               
                start_date: 0,
                end_date: 0,
                pagesize: 10,
                page: 1,        
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        let list = result.map(item=>{
                            return{
                                title: item['标题'],
                                des: item['详情'],
                            }
                        })   
                        
                        let des = list[0].des
                        this.ruleForm = {...list[0]}  
                        this.$refs.newsInfo.editNews(des)
                    }     
                }
            })
        },    
        // 发布
        publishNews(formName) {  
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.submitForm()
                }else{
                    return false
                }
            })           
        },
        // 提交发布
        submitForm(){
            let { title, des } = this.ruleForm
            if(this.serialId){
                this.flag = 2
            }else{
                this.flag = 1
            }
            let params = {
                opcode: this.$code.AddUpdateNews,
                i_serial: this.serialId,
                v_title: title,
                v_introduction: '',
                v_details: des,
                v_image: '',
                c_status: 0,
                i_flag: this.flag,
                v_flag: 1,               
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.disabled = true                     
                    if(this.serialId){
                        this.$message.success('新闻修改成功!')
                        this.$router.push('/newsQuery')
                    }else{
                        this.$message.success('新闻发布成功!')
                        this.$router.push({
                            path:'/newsDetail',
                            query:{
                                id: res.Message,
                            }
                        })
                    }
                }else{
                    this.$message.success('新闻发布失败!')
                }
            })
        },
        // 预览
        previewShow(formName){           
            this.$refs[formName].validate((valid) => {  
                if(valid){
                    this.showPreview = true                  
                }else{
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    return false;
                }
            })
        },      
        // 保存 到未发布状态
        saveNews(formName){           
            this.$refs[formName].validate((valid) => {  
                if(valid){
                    this.handleSubmit()
                }else{
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    return false;
                }
            })            
        },
        // 提交生成预览链接
        handleSubmit(){
            let { title, des } = this.ruleForm
            if(this.serialId){
                this.flag = 2
            }else{
                this.flag = 1
            }
            let params = {
                opcode: this.$code.AddUpdateNews,
                i_serial: this.serialId,
                v_title: title,
                v_introduction: '',
                v_details: des,
                v_image: '',
                c_status: 2,
                i_flag: this.flag,
                v_flag: 1,               
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){                   
                    if(this.serialId){
                        this.$message.success('新闻修改成功!')
                        this.$router.push({
                            path:'newsQuery',
                            query: {
                                status: 2
                            }
                        })
                    }else{                        
                        this.$message.success('新闻保存成功!')
                        this.$router.push({
                            path:'newsQuery',
                            query: {
                                status: 2
                            }
                        })
                        // this.$router.push({
                        //     path:'newsDetail',
                        //     query: {
                        //         id: res.Message,
                        //         status:2
                        //     }
                        // })
                    }
                }else{
                    this.$message.error('新闻发布失败!')
                    this.showPreview = false
                }
            })
        },
        handleClose(){
            this.showPreview = false
        } 
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.detail-wrap{
    width: 1200px;
    margin-top: 10px;
}
.detail{
    margin-top:30px
} 
.news-description{
    width: 1140px;
    padding: 20px 30px;
    min-height: 1000px;
    position: absolute;
    top: 60px;
    margin: 0 auto;
    border: 1px solid #eee;
    background: #fff;
}
.news-title{
    text-align: center;
    font-size: 30px;
    font-family: "黑体";    
}
.ql-editor{
    white-space: pre-wrap;
}
.ql-syntax{
    white-space: pre-wrap;
}
.icon-close{
    text-align: right;
}
.dialog-footer{
    position: absolute;
    bottom: 30px;
    right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/news/newsPage.vue